import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { User } from '../../types'

interface LeaderIdState {
    leaderId: string | undefined
    leader: User | undefined
}

const initialState: LeaderIdState = {
    leaderId: undefined,
    leader: undefined
}

export const leaderSlice = createSlice({
    name: 'leaderId',
    initialState,
    reducers: {
        setLeaderId: (state, action: PayloadAction<string | undefined>) => {
            state.leaderId = action.payload
        },
        setLeader: (state, action: PayloadAction<User | undefined>) => {
            state.leader = action.payload
        },

    },
})

export const { setLeaderId, setLeader } = leaderSlice.actions
export const selectLeaderId = (state: RootState) => state.leaderId
export default leaderSlice.reducer
